/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import Description from './Description/index'
import EmailAddress from './EmailAddress/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/New/Content/Email/Fields"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Fields.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<EmailAddress
  viewPath={`${viewPath}/EmailAddress`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
</div>
{children}
</React.Fragment>)
}